import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';

import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import {NgxImageCompressService} from 'ngx-image-compress';

/**
 * Providers
 */
import { Api } from '../providers/api/api';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Camera } from '@ionic-native/camera';
import { Push } from '@ionic-native/push';
import { Notifications } from '../providers/notifications/notifications';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
//import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';



/**
 * Data Access Objects
 */
import { UsuarioDAO } from '../daos/usuario-dao';
import { PedidoDAO } from '../daos/pedido-dao';




import { MyApp } from './app.component';

/**
 * Pipes
 */
import { MomentPipe } from '../pipes/moment-pipe';

/**
 * Components
 */
import { MenuComponent } from '../components/menu/menu';
import { LiberacaoPedidoComponent } from '../components/liberacao-pedido/liberacao-pedido';

/**
 * Pages
 */
import { LoginPage } from '../pages/login/login';

import { HomePage } from '../pages/home/home';  
import { CadastroUsuarioPage } from '../pages/cadastro-usuario/cadastro-usuario';
import { ListaBrindePage } from '../pages/lista-brinde/lista-brinde';
import { Empresa } from '../entities/empresa';
import { FinalizacaoPedidoPage } from '../pages/finalizacao-pedido/finalizacao-pedido'; 
import { ListaPedidoPage } from '../pages/lista-pedido/lista-pedido';
import { ListaPixPage } from '../pages/lista-pix/lista-pix';
import { VisualizaImagemPage } from '../pages/visualiza-imagem/visualiza-imagem';
import { CadastroReferenciaPage } from '../pages/cadastro-referencia/cadastro-referencia';
import { EnviarEmailSenhaPage } from '../pages/enviar-email-senha/enviar-email-senha';
import { InformacoesPessoaisPage } from '../pages/informacao-pessoal/informacao-pessoal';
import { SolicitarPixPage } from '../pages/solicitar-pix/solicitar-pix';
import { ReceberCartelaPage } from '../pages/receber-cartela/receber-cartela';
import { OrdemPagamentoPage } from '../pages/ordem-pagamento/ordem-pagamento';
import { CadastroReferenciaManterPage } from '../pages/cadastro-referencia-manter/cadastro-referencia-manter';









@NgModule({
    declarations: [
        MyApp,
        MomentPipe,
        LoginPage,        
        MenuComponent,
        LiberacaoPedidoComponent,
        HomePage,
        CadastroUsuarioPage,
        FinalizacaoPedidoPage,
        ListaPedidoPage,
        ListaPixPage,
        ListaBrindePage,
        VisualizaImagemPage,
        CadastroReferenciaPage,
        EnviarEmailSenhaPage,
        InformacoesPessoaisPage,
        SolicitarPixPage,
        ReceberCartelaPage,
        OrdemPagamentoPage,CadastroReferenciaManterPage
        
    ],
    imports: [
        BrowserModule,Ng2SearchPipeModule,
        HttpModule,
        IonicStorageModule.forRoot(),
        IonicModule.forRoot(MyApp, {
            monthNames: ['Janeiro', 'Fevereiro', 'Mar\u00e7o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthShortNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            dayNames: ['Domingo', 'Segunda-feira', 'Ter\u00e7a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'S\u00e1bado'],
            dayShortNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'S\u00e1b']
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        LoginPage,        
        MenuComponent,
        LiberacaoPedidoComponent,
        HomePage,
        CadastroUsuarioPage,
        FinalizacaoPedidoPage,
        ListaPedidoPage,
        ListaPixPage,
        ListaBrindePage,
        VisualizaImagemPage,
        CadastroReferenciaPage,
        EnviarEmailSenhaPage,
        InformacoesPessoaisPage,
        SolicitarPixPage,
        ReceberCartelaPage,
        OrdemPagamentoPage,CadastroReferenciaManterPage
    ],
    providers: [
        Api,
        StatusBar,
        SplashScreen,
        Camera,
        Push,        
        Notifications,
        UsuarioDAO,
        PedidoDAO,[NgxImageCompressService],
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ]
})
export class AppModule {
    private static empresa : Empresa = new Empresa();

    static getEmpresa(){
        this.empresa.Id = 1;
        this.empresa.Descricao = 'Dilady Lingerie';

        //this.empresa.Id = 2;
        //this.empresa.Descricao = 'Love Secret';
        return this.empresa;
    }

 }


// WEBPACK FOOTER //
// ./src/app/app.module.ts